import { SPARTAN_PRODUCT_EXTERIOR_TRACKING } from '@/app/lcv/components/sections/spartan/products/exterior/tracking';
import {
  getSpartanProductLenis,
  notifySpartanProductScroll,
} from '@/app/lcv/components/sections/spartan/products/shared/product-scroll/store';

const SPARTAN_PARALLAX_PAUSED_CLASS = 'spartan-parallax-paused';
const SPARTAN_PARALLAX_SELECTOR = '[data-spartan-parallax]';
const SPARTAN_PARALLAX_FROZEN_TRANSFORM = '--spartan-parallax-frozen-transform';

/**
 * Drop the product-scroll parallax freeze so a scroll jump does not paint
 * stale transforms against the new scroll position.
 */
export const releaseSpartanParallaxPause = (): void => {
  if (
    !document.documentElement.classList.contains(SPARTAN_PARALLAX_PAUSED_CLASS)
  ) {
    return;
  }

  document.documentElement.classList.remove(SPARTAN_PARALLAX_PAUSED_CLASS);
  document
    .querySelectorAll<HTMLElement>(SPARTAN_PARALLAX_SELECTOR)
    .forEach((element) => {
      element.style.removeProperty(SPARTAN_PARALLAX_FROZEN_TRANSFORM);
    });
};

/** Force preview scroll subscribers to re-read layout after a jump scroll. */
const syncSpartanProductScrollAfterJump = (): void => {
  notifySpartanProductScroll();
  // Native jump scrolls (and some Lenis immediate scrolls) may not emit a
  // scroll event; a second pass after paint catches post-release layout.
  requestAnimationFrame(() => {
    notifySpartanProductScroll();
  });
};

/** Instantly scroll so `element` is vertically centered in the viewport. */
export const scrollElementToViewportCenter = (element: HTMLElement): void => {
  const rect = element.getBoundingClientRect();
  const top = Math.max(
    0,
    window.scrollY + rect.top - (window.innerHeight - rect.height) / 2
  );
  const lenis = getSpartanProductLenis();

  if (lenis) {
    lenis.scrollTo(top, { force: true, immediate: true });
  } else {
    window.scrollTo({ top, behavior: 'instant' });
  }

  syncSpartanProductScrollAfterJump();
};

/** Center the exterior 360 track when present. */
export const scrollSpartanExteriorThreesixtyIntoView = (): void => {
  const track = document.querySelector<HTMLElement>(
    `[data-test="${SPARTAN_PRODUCT_EXTERIOR_TRACKING.threesixtyTrack}"]`
  );
  if (!track) return;

  scrollElementToViewportCenter(track);
};
